import React, { useEffect, useState } from "react";
import axios from "axios";
import cup from "../../../../../../../../assets/images/cup 2.png";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import AuditionJuryMarkedView from "./AuditionJuryMarkedView";
import { serverInfo } from "../../../../../../../../App";
import { useContext } from "react";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";

const AuditionJuryMarkedVideos = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [events, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/audition-admin/audition/lives").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.lives);
        // console.log(res.data.lives);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Filter live auditions videos"
        image={cup}
        count={"Zero"}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AuditionJuryMarkedView
          data={events}
          viewJuryMark={`/audition-admin/audition/jury-marked-videos`}
          viewResult={`/audition-admin/audition/round-result`}
        />
      )}
    </>
  );
};

export default AuditionJuryMarkedVideos;
